export enum ContactType {
    Undefined = 0,
    Buyer,
    Seller,
    Both,
    Affiliate,
    Agent,
}
